import React,{useState,useEffect} from 'react'
import axios from 'axios'
import { Spinner } from 'flowbite-react'
export default function AlumniTable({course_id}) {
const [loading,setLoading]=useState(true)
  const [data,setData]=useState()
  const [lan, setLan] = useState('bangla')
  const baseURL="https://mukti-backend-bd.onrender.com"
  const getData = async()=>{
      try{
        setLoading(false)
        const res = await axios.get(`${baseURL}/alumni/${course_id}`)
        console.log(res.data)
        setData(res.data)
       
      }catch(e){
        console.log(e)
      }
    }
    useEffect(()=>{
      if (localStorage.getItem('language') === 'english') {
        setLan('english')
        } else {
        setLan('bangla')
        }
      getData()
    },[])
  return loading? <Spinner/> : (
    <div class="relative overflow-x-scroll mx-4 border border-gray-200 shadow-md sm:rounded-lg">
    <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
      <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
        <tr>
          <th scope="col" class="px-6 py-3">
            <span class="sr-only">Image</span>
          </th>
          <th scope="col" class="px-6 py-3">
            Name
          </th>
          <th scope="col" class="px-6 py-3">
            Job Title
          </th>
          <th scope="col" class="px-6 py-3">
            Placed Company
          </th>
          <th scope="col" class="px-6 py-3">
            Experience
          </th>
        </tr>
      </thead>
      <tbody>
        {/* {data.map(a => (
          <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
            <td class="w-32 p-4">
              <img class="hidden md:flex w-20 h-20 aspect-square rounded-full" src={a.image} />
            </td>
            <td class="px-6 py-4 font-semibold text-gray-900 dark:text-white">
              {a.name}
            </td>
            <td class="px-6 py-4">
              {a.title}
            </td>
            <td class="w-32 p-4">
              <img class="h-20 w-20 rounded" src={a.company} />
            </td>
            <td class="px-6 py-4">
              {a.experience}
            </td>
          </tr>
        ))} */}
        <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
            <td class="w-32 p-4">
              <img class="hidden md:flex w-20 h-20 aspect-square rounded-full" src="https://i.postimg.cc/9F2zGBcz/image.png" />
            </td>
            <td class="px-6 py-4 font-semibold text-gray-900 dark:text-white">
             খাদিজা 
            </td>
            <td class="px-6 py-4">
              Packaging manager
            </td>
            <td class="w-32 p-4">
              Uniliver
            </td>
            <td class="px-6 py-4">
              2 Years
            </td>
          </tr>
          <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
            <td class="w-32 p-4">
              <img class="hidden md:flex w-20 h-20 aspect-square rounded-full" src="https://i.postimg.cc/Rh6hXPNn/image.png" />
            </td>
            <td class="px-6 py-4 font-semibold text-gray-900 dark:text-white">
            আনিকা
            </td>
            <td class="px-6 py-4">
              Clay master
            </td>
            <td class="w-32 p-4">
             Adi Bostro Bitan
            </td>
            <td class="px-6 py-4">
              6 months
            </td>
          </tr>


      </tbody>
    </table>
  </div>
  )
}
